export default __webpack_public_path__ + "static/media/menu-logout-white.0837bb13.svg";